var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4082 6.48323V14.5916C2.4082 16.1749 3.5332 16.8249 4.89987 16.0416L6.8582 14.9249C7.2832 14.6832 7.99154 14.6582 8.4332 14.8832L12.8082 17.0749C13.2499 17.2916 13.9582 17.2749 14.3832 17.0332L17.9915 14.9666C18.4499 14.6999 18.8332 14.0499 18.8332 13.5166V5.40823C18.8332 3.8249 17.7082 3.1749 16.3415 3.95823L14.3832 5.0749C13.9582 5.31657 13.2499 5.34156 12.8082 5.11656L8.4332 2.93323C7.99154 2.71656 7.2832 2.73323 6.8582 2.9749L3.24987 5.04157C2.7832 5.30823 2.4082 5.95823 2.4082 6.48323Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6333 3.33325V14.1666",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6084 5.5166V16.6666",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlackIcon);
export default __webpack_public_path__ + "static/media/MapBlackIcon.1dd1e4acbc85908b87efd312b7ae42d9.svg";
export { ForwardRef as ReactComponent };